import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';

export const RoiHubHeaderStyles = {
  container: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    padding: ${theme.spacing(4)};
    padding-bottom: ${theme.spacing(2)};
  `,
  title: css`
    font-size: 28px;
    font-weight: 600;
  `,
  buttonContainer: css`
    flex: 1;
    text-align: right;
  `,
};
